import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Button } from 'src/Components'
import { IconLock } from 'src/Components/shared/Icon'
import styles from './ChartTable.module.scss'

const propTypes = {
  onChange: PropTypes.func,
  locked: PropTypes.bool,
  selectedTab: PropTypes.bool
}

const tabLockIconPropTypes = {
  className: PropTypes.string
}

const TABS = [
  {
    key: 'monthlyRevenue',
    render: (
      <FormattedMessage
        id='AirDna.chartTab.monthlyRevenue'
        defaultMessage='Monthly Revenue'
      />
    )
  },
  {
    key: 'nightlyRate',
    lockable: true,
    render: (
      <FormattedMessage
        id='AirDna.chartTab.nightlyRate'
        defaultMessage='Nightly Rate'
      />
    )
  },
  {
    key: 'monthlyOccupancy',
    lockable: true,
    render: (
      <FormattedMessage
        id='AirDna.chartTab.monthlyOccupancy'
        defaultMessage='# of nights'
      />
    )
  }
]

const TabLockIcon = ({ className, ...restProps }) => (
  <IconLock className={classnames(className, styles.lessMargin)} />
)

const ChartTable = ({ onChange, locked, selectedTab }) => {
  return (
    <div className={styles.ChartTableContainer}>
      <ul className={`tabs-v2 ${styles.tabsContainer}`}>
        {TABS.map(({ key, render, lockable }) => (
          <li
            key={key}
            className={classnames(
              styles.tab,
              selectedTab === key && styles.active
            )}
          >
            <Button
              disabled={locked && lockable}
              onClick={onChange(key)}
              iconStart={locked && lockable && TabLockIcon}
              children={render}
              className={styles.button}
            />
          </li>
        ))}
      </ul>
      <div
        id='chart-container'
        className={`chart-container chart-container--bar-chart ${styles.chart}`}
      >
        <svg id='air-dna-chart-svg' className='bar-chart' />
      </div>
    </div>
  )
}

ChartTable.propTypes = propTypes
TabLockIcon.propTypes = tabLockIconPropTypes

export default ChartTable
